import { render, staticRenderFns } from "./AlarmMgmt.vue?vue&type=template&id=6ca01f7b&scoped=true"
import script from "./AlarmMgmt.vue?vue&type=script&lang=js"
export * from "./AlarmMgmt.vue?vue&type=script&lang=js"
import style0 from "./AlarmMgmt.vue?vue&type=style&index=0&id=6ca01f7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca01f7b",
  null
  
)

export default component.exports